import { render } from "./GalleryApp.vue?vue&type=template&id=bfc844fc"
import script from "./GalleryApp.vue?vue&type=script&lang=js"
export * from "./GalleryApp.vue?vue&type=script&lang=js"

import "./GalleryApp.vue?vue&type=style&index=0&id=bfc844fc&lang=css"

import exportComponent from "/home/nimens/projects/cafe-portos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__